import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    GroupPanel,
    Grouping,
    GroupItem,
    Pager,
    Summary,
    TotalItem,
    SortByGroupSummaryInfo,
    Format,
    Editing
} from 'devextreme-react/data-grid';
import Request from "../../components/Request/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import './HesapForm.scss';
import CustomStore from 'devextreme/data/custom_store';

import TextBox from 'devextreme-react/text-box';
import FileUploader from 'devextreme-react/file-uploader';
import Form, { ButtonItem, ButtonOptions, Item, Label, RequiredRule, CheckBox, TabbedItem, TabPanelOptions, Tab, SimpleItem } from "devextreme-react/form";
import GostergeLabelTemplate from './GostergeLabelTemplate.js';
import Box, {
    Item as BoxItem
} from 'devextreme-react/box';
import { NumberBox } from 'devextreme-react';
import { showToast } from '../../utils/Utils';
import { ToastType } from '../../constants/Constants';
import * as AppActions from '../../actions/AppActions';

const HesapForm = (props) => {

    const dispatch = useDispatch();

    const listeBasligi = "Hesap Form ";
    const [store, setStore] = useState(null);
    const [calismaDetay, setCalismaDetay] = useState(new CustomStore({ key: 'id' }));
    const [calismaYilDetay, setCalismaYilDetay] = useState(new CustomStore({ key: 'id' }));
    const [calismaYilAsgariUcretDetay, setCalismaYilAsgariUcretDetay] = useState(new CustomStore({ key: 'id' }));
    const [emeklilikKosulDetay, setEmeklilikKosulDetay] = useState(new CustomStore({ key: 'id' }));

    const [tcKimlikNo, setTcKimlikNo] = useState("");
    const [storeHesapTuru, setStoreHesapTuru] = useState([]);
    const [storeBakmaklaYukumluOlduguEsCocuk, setStoreBakmaklaYukumluOlduguEsCocuk] = useState([
        { id: 'YOK', name: 'Yok' },
        { id: 'VAR', name: 'Var' }
    ]);
    const [storeHesaplaDetayTuru, setStoreHesaplaDetayTuru] = useState([]);
    const [hesaplaDetayTuru, setHesaplaDetayTuru] = useState("ASKERLIK");

    const [numberFormat, setNumberFormat] = useState("#,##0");
    const [ondalikFormat, setOndalikFormat] = useState("#,##0.00");

    //format:'#,##0'

    const decimalFormat = { type: "fixedPoint", precision: 2 };

    const [hizmetEkleDataSource, setHizmetEkleDataSource] = useState([]);
    const [belgeTuruDataSource, setBelgeTuruDataSource] = useState([]);
    const [baslangicDonem, setBaslangicDonem] = useState();
    const [bitisDonem, setBitisDonem] = useState();
    const [belgeTuru, setBelgeTuru] = useState("4a");
    const [asgariUcretOran, setAsgariUcretOran] = useState(1.0);

    useEffect(() => {
        setStore(getStore());
        setBelgeTuruDataSourceList();
        setHesapTuruList();
        setHesaplaDetayTuruList();
        // if (tcKimlikNo.length == 0) {
        //     setTcKimlikNo("13711130782");
        // }
    }, [])

    useEffect(() => {
        if (tcKimlikNo && tcKimlikNo.length == 11) {
            setStore(getStore());
        }

    }, [tcKimlikNo])


    function setHesapTuruList() {
        if (!storeHesapTuru || storeHesapTuru.length == 0) {
            const request = new Request("/emeklilik-app/api/enum-tanim/getList/HesapTuru", "GET");
            request.run()
                .then(response => {
                    if (response.data && response.data.data) {
                        setStoreHesapTuru(response.data.data);
                    }
                });
        }
    }
    function setHesaplaDetayTuruList() {
        if (!storeHesaplaDetayTuru || storeHesaplaDetayTuru.length == 0) {
            const request = new Request("/emeklilik-app/api/enum-tanim/getList/HesaplaDetayTuru", "GET");
            request.run()
                .then(response => {
                    if (response.data && response.data.data) {
                        setStoreHesaplaDetayTuru(response.data.data);
                    }
                });
        }
    }

    function setBelgeTuruDataSourceList() {
        if (!belgeTuruDataSource || belgeTuruDataSource.length == 0) {

            let array = [
                { id: "4a", name: "4a" },
                { id: "4b", name: "4b" },
                { id: "4c", name: "4c" },
            ];

            setBelgeTuruDataSource(array);
        }
    }

    function setCalismaDetayDtoList(list) {

        if (list == null) {
            list = [];
        }
        setCalismaDetay(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                return list;
            }
        }));
    }

    function setCalismaYilDetayDtoList(list) {

        if (list == null) {
            list = [];
        }
        setCalismaYilDetay(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                return list;
            }
        }));
    }
    function setCalismaYilAsgariUcretDetayDtoList(list) {

        if (list == null) {
            list = [];
        }
        setCalismaYilAsgariUcretDetay(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                return list;
            }
        }));
    }
    function setEmeklilikKosulDtoList(list) {

        if (list == null) {
            list = [];
        }
        setEmeklilikKosulDetay(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                return list;
            }
        }));
    }


    const getStore = () => {
        if (props.data) {
            setStoreData(null);
            setTimeout(function () { //Start the timer
                setStoreData(props.data);
            }.bind(this), 1000)

            return;
        }

        if (!tcKimlikNo || tcKimlikNo.length == 0) {
            return;
        }
        dispatch(AppActions.setLoading(true, "Kayıt yükleniyor.."));
        const request = new Request("/emeklilik-app/api/hesap/getKayit/" + tcKimlikNo, "GET");
        return request.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setStoreData(response.data.data);
                } else {
                    setStoreData(null);
                }
                dispatch(AppActions.setLoading(false, ""));
            });
    }

    const setStoreData = (data) => {
        if (data) {
            setStore(data);
            setCalismaDetayDtoList(data.calismaDetayDtoList);
            setCalismaYilDetayDtoList(data.calismaYilDtoList);
            setCalismaYilAsgariUcretDetayDtoList(data.calismaYilAsgariUcretDtoList);
            setHizmetEkleDataSource(data.ekCalismaDetayDtoList);
            setEmeklilikKosulDtoList(data.emeklilikKosulDtoList);
        } else {
            setStore(null);
            setCalismaDetayDtoList(null);
            setCalismaYilDetayDtoList(null);
            setCalismaYilAsgariUcretDetayDtoList(null);
            setHizmetEkleDataSource(null);
            setEmeklilikKosulDtoList(null);
        }
    }

    const yenile = () => {
        setStore(getStore());
    }
    const tekrarHesapla = () => {
        let st = {};// store;

        // st.kazancDtoList = store.kazancDtoList;
        // st.asgariUcretTanimDtoList = store.asgariUcretTanimDtoList;
        // st.enflasyonTanimDtoList = store.enflasyonTanimDtoList;
        st.hesapTarihi = store.hesapTarihi;
        st.hesapTuru = store.hesapTuru;
        st.bakmaklaYukumluOlduguEsCocuk = store.bakmaklaYukumluOlduguEsCocuk;
        st.raporOrani = store.raporOrani;
        st.calismaDetayDtoList = store.calismaDetayDtoList;
        st.personelDto = store.personelDto;
        st.pekTavanKontroluDevreDisi = store.pekTavanKontroluDevreDisi;

        st.ekCalismaDetayDtoList = hizmetEkleDataSource;
        // st.calismaYilDtoList = calismaYilDetay;
        // st.calismaYilAsgariUcretDtoList = calismaYilAsgariUcretDetay;
        dispatch(AppActions.setLoading(true, "Hesaplama tekrar yapılıyor.."));
        const request = new Request("/emeklilik-app/api/hesap/tekrarHesapla", "POST", st);
        return request.run()
            .then(response => {

                if (response.data && response.data.data) {
                    setStoreData(response.data.data);
                } else {
                    setStoreData(null);
                }
                dispatch(AppActions.setLoading(false, ""));
            });
    }
    function textValueChanged(data) {
        //loginInfo.name = data.value;
        setTcKimlikNo(data.value);
        //setLoginInfo(loginInfo);
    }
    function ondalikFormatValueChanged(data) {
        setOndalikFormat(data.value);
    }
    function numberFormatValueChanged(data) {
        if (data.value) {
            setNumberFormat(data.value);
        }
    }

    function onBelgeTuruValueChanged(data) {
        if (data.value) {
            setBelgeTuru(data.value);
        }
    }

    function onHesaplaDetayTuruChanged(data) {
        if (data.value) {
            setHesaplaDetayTuru(data.value);
        }
    }


    function onBaslangicDonemValueChanged(data) {
        if (data.value) {
            setBaslangicDonem(data.value);
        }
    }
    function onBitisDonemValueChanged(data) {
        if (data.value) {
            setBitisDonem(data.value);
        }
    }
    function onAsgariUcretOranValueChanged(data) {
        if (data.value) {
            setAsgariUcretOran(data.value);
        }
    }
    function deleteDetay(data) {
        if (data) {
            let newData = hizmetEkleDataSource.filter((donem) => donem.donem != data.donem);
            setHizmetEkleDataSource(newData);
        }
    }
    const detayEkle = () => {
        if (!belgeTuru) {
            showToast('Belge türü zorunlu alan. Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        if (!asgariUcretOran || asgariUcretOran < 1) {
            showToast('Asgari Ücret oranı zorunlu alan. Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        if (!baslangicDonem) {
            showToast('Başlangıç dönem zorunlu alan. Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        if (!bitisDonem) {
            showToast('Bitiş dönem zorunlu alan. Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        if (!hesaplaDetayTuru) {
            showToast('Hesap Detay Türü zorunlu alan. Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        let data = {
            belgeTuru: belgeTuru,
            asgariUcretOran: asgariUcretOran,
            basTarihi: baslangicDonem,
            bitisTarihi: bitisDonem,
            hesaplaDetayTuru: hesaplaDetayTuru
        }


        // data.donemBas = donemDataSource.find((donem) => donem.id == baslangicDonem).name;
        // data.donemBitis = donemDataSource.find((donem) => donem.id == bitisDonem).name;
        data.detayList = hizmetEkleDataSource;
        dispatch(AppActions.setLoading(true, "Detay hesaplanıyor.."));
        const request = new Request("/emeklilik-app/api/hesap/detayEkleHesapla", "POST", data);
        return request.run()
            .then(response => {

                if (response.data && response.data.data) {
                    setHizmetEkleDataSource(response.data.data);
                }
                dispatch(AppActions.setLoading(false, "Dosya Yükleniyor.."));
            });
    }
    function hizmetDatasourceTemizle() {
        let array = [];
        setHizmetEkleDataSource(array);
    }
    function donemRender(rowData) {
        let kullaniciTanimli = rowData.row.data.kullaniciTanimli;

        if (kullaniciTanimli) {
            return <div style={{ backgroundColor: '#F6BB42', margin: 0 }}> <b>{rowData.text}</b></div>
        }
        return rowData.text;
    }

    return (
        <div >

            <h3 className={'dx-icon-product'} >{listeBasligi}</h3>
            {props.data == null ? (
                <div className="editors">
                    <div className="editors-container">
                        <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>

                            <TextBox defaultValue=""
                                placeholder="TcKimlikNo Giriniz"
                                stylingMode="outlined"
                                label="TcKimlikNo"
                                labelMode="floating"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={textValueChanged} >
                                <Label text='Adı Soyadı' />
                            </TextBox>

                            <TextBox defaultValue={numberFormat}
                                placeholder="NumberFormat"
                                stylingMode="outlined"
                                label="Number Format"
                                labelMode="floating"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={numberFormatValueChanged} />
                            <TextBox defaultValue={ondalikFormat}
                                placeholder="Format"
                                stylingMode="outlined"
                                label="Format"
                                labelMode="floating"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={ondalikFormatValueChanged} />

                            <Button icon="find" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }} onClick={yenile}></Button>
                            <Button icon="refresh" width={150} text="Hesapla" type={'success'} style={{ fontSize: "15px" }} onClick={tekrarHesapla}></Button>


                        </div>
                    </div>
                </div>
            ) : (<div></div>)}
            <Form formData={store} colCount={1} id="form" labelLocation={"left"} className="option" >
                <TabbedItem  >
                    <TabPanelOptions deferRendering={false} />
                    <Tab title="Genel Bilgileri">
                        <Item itemType="group" colCount={5} colSpan={4}>

                            <Item itemType="group" caption={"Kişi Bilgileri"} maxW colCount={1} colSpan={1}>
                                <Item dataField={'personelDto.adiSoyadi'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Adı Soyadı' />
                                </Item>
                                <Item dataField={'personelDto.cinsiyet'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Cinsiyet' />
                                </Item>
                                <Item dataField={'personelDto.dogumTarihi'} editorType={'dxDateBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, type: "date", displayFormat: "dd.MM.yyyy" }}>
                                    <Label text='Doğum Tarihi' />
                                </Item>
                                <Item dataField={'personelDto.tcKimlikNo'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Tc Kimlik No' />
                                </Item>
                                <Item dataField={'personelDto.iseGirisTarihi'} editorType={'dxDateBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, type: "date", displayFormat: "dd.MM.yyyy" }}>
                                    <Label text='İşe Giriş Tarihi' />
                                </Item>
                                <Item dataField={'personelDto.yas'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Yaş' />
                                </Item>
                                <Item dataField={'personelDto.sure'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Süre' />
                                </Item>

                            </Item>
                            <Item itemType="group" caption={"Hesap Değişkenleri"} colCount={1} colSpan={1}>
                                <Item dataField={'hesapTarihi'} editorType={'dxDateBox'}
                                    editorOptions={{
                                        stylingMode: 'outlined',
                                        readOnly: false,
                                        //type: "date", 
                                        //displayFormat: "dd.MM.yyyy",
                                        pickerType: "rollers"
                                    }}>
                                    <RequiredRule message="Hesap Tarihi bilgisi gerekli" />
                                    <Label text='Hesap Tarihi' />
                                </Item>


                                <Item disabled={false} dataField={'hesapTuru'} editorType={'dxSelectBox'}
                                    editorOptions={{
                                        dataSource: storeHesapTuru,
                                        valueExpr: "id",
                                        displayExpr: "name",
                                        placeholder: "Select a value...",
                                    }}>
                                    <RequiredRule message="Hesap Türü bilgisi gerekli" />
                                    <Label text='Hesap Türü' />
                                </Item>

                                <Item disabled={false} dataField={'bakmaklaYukumluOlduguEsCocuk'} editorType={'dxSelectBox'}
                                    editorOptions={{
                                        dataSource: storeBakmaklaYukumluOlduguEsCocuk,
                                        valueExpr: "id",
                                        displayExpr: "name",
                                        placeholder: "Select a value...",
                                    }}>
                                    <RequiredRule message="Bakmakla Yükümlü Olduğu Eş Çocuk bilgisi gerekli" />
                                    <Label text='BYO Eş-Ç ' />
                                </Item>

                                <Item disabled={false} dataField={'raporOrani'} editorType={'dxNumberBox'}
                                    editorOptions={{
                                        min: 0,
                                        max: 100
                                    }}>
                                    <Label text='Rapor Oranı ' />
                                </Item>
                                <Item disabled={false} dataField={'pekTavanKontroluDevreDisi'} editorType={'dxCheckBox'}
                                    editorOptions={{ }}>
                                    <Label text='Tavan Kontrolü Devre Dışı' />
                                </Item>
                            </Item>

                        </Item>
                    </Tab>
                    <Tab title="Çalışma Bilgileri">
                        <Item itemType="group" colCount={5} colSpan={4}>
                            <Item itemType="group" caption={"Çalışma Bilgileri"} maxW colCount={1} colSpan={1}>

                                <Item dataField={'personelDto.calismaGunDto.toplamGun'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Toplam Gün' />
                                </Item>
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4a'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4A Gün Sayısı' />
                                </Item>
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4b'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4B Gün Sayısı' />
                                </Item>
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4c'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4C Gün Sayısı' />
                                </Item>
                            </Item>
                            <Item itemType="group" caption={"Son 7 Yıl"} maxW colCount={1} colSpan={1}> 
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4aSon7yildakiGun'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4A Gün Sayısı(Son 7 Yıl)' />
                                </Item>
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4bSon7yildakiGun'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4B Gün Sayısı(Son 7 Yıl)' />
                                </Item>
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4cSon7yildakiGun'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4C Gün Sayısı(Son 7 Yıl)' />
                                </Item>
                            </Item>
                            <Item itemType="group" caption={"Statü(4a,4b,4c)Emeklilik için Gerekli Gün"} maxW colCount={1} colSpan={1}> 
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4aEmeklilikIcinGerekliGun'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4A Gün Sayısı(Son 7 Yıl)' />
                                </Item>
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4bEmeklilikIcinGerekliGun'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4B Gün Sayısı(Son 7 Yıl)' />
                                </Item>
                                <Item dataField={'personelDto.calismaGunDto.toplamGun4cEmeklilikIcinGerekliGun'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='4C Gün Sayısı(Son 7 Yıl)' />
                                </Item>
                            </Item>
                        </Item>
                    </Tab>
                    <Tab title="RAT-a">
                        <Item itemType="group" colCount={4} colSpan={4}>
                            <Item itemType="group" colCount={3} colSpan={2}>
                                {/* caption={"A-1 A-2 A Bilgileri"}  */}
                                <Item itemType="group" caption={"2000 Öncesi"} maxW colCount={1} colSpan={1}>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.ortalamaKazanc90Oncesi'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text={'OYK-'} />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.gostergeDeger90Oncesi'} editorType={'dxTextBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                        <Label text={'Gösterge'} />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.abo1Deger'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text={'ABO 1'} />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.abo1KatsayiGostergeDegerHesaplanan'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text={"A1 Hesaplanan"} />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.abo1KatsayiGostergeDeger'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text={"A1 Değer"} />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.gunOran2000OncesiVeToplam'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text={"Ksm 1"} />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.toplamMaasTutari'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text={"Toplam(A1)"} />
                                    </Item>
                                </Item>
                                <Item itemType="group" caption={"2000-2008/10 Arası"} maxW colCount={1} colSpan={1}>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA2Dto.toplamKazanc'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='OAK 2' />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA2Dto.abo2Deger'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='ABO 2' />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA2Dto.toplamKazancAboDegerHesaplanan'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="A2 Hesaplanan" />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA2Dto.toplamKazancAboDeger'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="A2 Değer" />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA2Dto.gunOran2000Ve2008Donem1'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="Ksm 2" />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA2Dto.toplamMaasTutari'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="Toplam(A2)" />
                                    </Item>
                                </Item>
                                <Item itemType="group" caption={"....-2008/10 Toplam"} maxW colCount={1} colSpan={1}>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.maxAMaasHesaplanan'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="A (A1+A2)" />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.maxAMaas'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="A Değer" />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.yilCarpan'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Çarpan' />
                                    </Item>
                                    <Item dataField={'hesapMaasRata.hesapMaasRataA.toplamMaasTutari'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Toplam(A)' />
                                    </Item>
                                </Item>
                            </Item>
                            <Item itemType="group" caption={"2008/10 Sonrası"} colCount={1} colSpan={1}>
                                <Item dataField={'hesapMaasRata.hesapMaasRataB.kazancToplam2008Sonrasi'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='OAK 3' />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataB.abo3Deger'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='ABO 3' />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataB.maxBMaasHesaplanan'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="B Hesaplanan" />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataB.maxBMaas'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="B Değer" />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataB.gunOran20008Donem2Sonrasi'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="Ksm 3" />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataB.toplamMaasTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="Toplam(B)" />
                                </Item>
                            </Item>
                            <Item itemType="group" caption={"Toplam Bilgileri"} colCount={1} colSpan={1}>
                                <Item dataField={'hesapMaasRata.toplamMaasAveBTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='C  ( A + B )' />
                                </Item>
                                <Item dataField={'hesapMaasRata.yuzdeCarpan'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Ocak ???' />
                                </Item>
                                <Item dataField={'hesapMaasRata.araMaasTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Maaş Ocak' />
                                </Item>
                                <Item dataField={'hesapMaasRata.ekOdemeTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Ek Ödeme' />
                                </Item>
                                <Item dataField={'hesapMaasRata.emekliOldugundakiMaasi'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Emekli Maaşı' />
                                </Item>
                                <Item dataField={'hesapMaasRata.emeklilikSonrasiYuzdeFark'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Enflasyon Fark' />
                                </Item>
                                <Item dataField={'hesapMaasRata.toplamMaasTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Toplam' />
                                </Item>
                                <Item dataField={'hesapMaasRata.ileriTarihliMassHesapfark'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Fark' />
                                </Item>
                            </Item>

                        </Item>
                    </Tab>
                    <Tab title="RAT-b">
                        <Item itemType="group" colCount={4} colSpan={4}>
                            <Item itemType="group" colCount={3} colSpan={2}>
                                <Item itemType="group" caption={"2000 Öncesi"} maxW colCount={1} colSpan={1}>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.gunOran90Oncesi'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: numberFormat }}>
                                        <Label text='99/Aralık Bsm' />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.gostergeDeger90Oncesi'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Gösterge' />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.abo1Deger'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='ABO 1' />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.gunOran2000OncesiVeToplam'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Ksm 1' />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.toplamMaasTutari'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Toplam(A1)' />
                                    </Item>
                                </Item>

                                <Item itemType="group" caption={"2000-2008/10 Arası	"} maxW colCount={1} colSpan={1}>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA2Dto.agirlikliOrtalama'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Ağr. Ortalama' />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA2Dto.abo2Deger'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='ABO 2' />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA2Dto.gunOran2000Ve2008Donem1'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Ksm 2' />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA2Dto.toplamMaasTutari'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text='Toplam' />
                                    </Item>
                                </Item>
                                <Item itemType="group" caption={"....-2008/10 Arası	"} maxW colCount={1} colSpan={1}>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.toplamMaasA1VeA2Tutari'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="A (A1+A2)" />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.bakiyeSdo'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="Bakiye SDÖ" />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.araToplam'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="Ara Toplam" />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.aAyligiCarpani'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="Çarpan" />
                                    </Item>
                                    <Item dataField={'hesapMaasRatb.hesapMaasRatbA.toplamMaasTutari'} editorType={'dxNumberBox'}
                                        editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                        <Label text="Toplam(A2)" />
                                    </Item>
                                </Item>
                            </Item>
                            <Item itemType="group" caption={"2008/10 Sonrası"} colCount={1} colSpan={1}>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbB.kazancToplam2008Sonrasi'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='OAK 3' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbB.abo3Deger'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='ABO 3' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbB.maxBMaasHesaplanan'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="B Hesaplanan" />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbB.maxBMaas'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="B Değer" />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbB.gunOran20008Donem2Sonrasi'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="Ksm 3" />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbB.toplamMaasTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text="Toplam(A)" />
                                </Item>
                            </Item>
                            <Item itemType="group" caption={"Toplam Bilgileri"} colCount={1} colSpan={1}>
                                <Item dataField={'hesapMaasRatb.toplamMaasAveBTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='C  ( A + B )' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.yuzdeCarpan'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Ocak ???' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.araMaasTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Maaş Ocak' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.ekOdemeTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Ek Ödeme' />
                                </Item>
                                <Item dataField={'hesapMaasRata.emekliOldugundakiMaasi'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Emekli Maaşı' />
                                </Item>
                                <Item dataField={'hesapMaasRata.emeklilikSonrasiYuzdeFark'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Enflasyon Fark' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.toplamMaasTutari'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Toplam' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.ileriTarihliMassHesapfark'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Fark' />
                                </Item>
                            </Item>
                        </Item>
                    </Tab>
                    <Tab title="Gösterge-ABO">
                        <Item itemType="group" colCount={4} colSpan={4}>

                            <Item itemType="group" caption={"Sonuç"} maxW colCount={1} colSpan={1}>
                                <Item dataField={'personelGostergeDto.yilSayisi'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Yıl Sayısı' />
                                </Item>
                                <Item dataField={'personelGostergeDto.gostergeTipi'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Gösterge Tipi' />
                                </Item>
                                <Item dataField={'personelGostergeDto.ortalamaKazanc'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Ortalama Kazanc' />
                                </Item>
                                <Item dataField={'personelGostergeDto.gostergeDeger'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='Gösterge Deger' />
                                </Item>
                                <Item dataField={'personelGostergeDto.aboDeger'} editorType={'dxTextBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true }}>
                                    <Label text='ABO(baz)' />
                                </Item>
                            </Item>
                            <Item itemType="group" caption={"Rat-a"} maxW colCount={1} colSpan={1}>
                                <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.baz'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Baz' />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.yas'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: numberFormat }}>
                                    <Label text='Yaş' />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.gun'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: numberFormat }}>
                                    <Label text='Gün' />
                                </Item>
                                <Item dataField={'hesapMaasRata.hesapMaasRataA.hesapMaasRataAA1Dto.abo1Deger'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text={'ABO 1'} />
                                </Item>
                            </Item>

                            <Item itemType="group" caption={"Rat-b"} maxW colCount={1} colSpan={1}>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.baz'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='Baz' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.yas'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: numberFormat }}>
                                    <Label text='Yaş' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.gun'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: numberFormat }}>
                                    <Label text='Gün' />
                                </Item>
                                <Item dataField={'hesapMaasRatb.hesapMaasRatbA.hesapMaasRatbAA1Dto.abo1Deger'} editorType={'dxNumberBox'}
                                    editorOptions={{ stylingMode: 'outlined', readOnly: true, format: ondalikFormat }}>
                                    <Label text='ABO 1' />
                                </Item>
                            </Item>
                        </Item>
                    </Tab>
                    <Tab title="Çalışma Detay Bilgileri" >
                        <DataGrid
                            className={props.data == null ? 'gridCalismaDetay' : "gridCalismaDetayPopup"}
                            width="100%"
                            dataSource={calismaDetay}
                            key="id"
                            keyExpr="id"
                            showBorders={true}
                            focusedRowEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={"widget"}
                            columnAutoWidth={false}
                            selection={{ mode: 'single', deferred: true }}
                        >
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={true} />
                            <FilterRow visible={true} />
                            <Export enabled={true} />
                            <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                            <Scrolling columnRenderingMode="virtual" showScrollbar="always" />

                            <Paging defaultPageSize={1000} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                            {/* <Column dataField={'id'} width={90} caption={'Id'} visible={false} /> */}
                            <Column dataField={'kullaniciTanimli'} width={50} caption={'Kullanıcı Tanımlı'} />
                            <Column dataField={'hesaplaDetayTuru'} width={50} caption={'Tanım'} />
                            <Column dataField={'donem'} width={90} caption={'Dönem'}
                                cellRender={donemRender}
                            />
                            <Column dataField={'yil'} width={90} caption={'Yıl'} groupIndex={0} />
                            <Column dataField={'ay'} width={90} caption={'Ay'} />
                            <Column dataField={'sigortaKolu'} width={150} caption={'Sigorta Kolu'} />
                            <Column dataField={'sigortaStatu'} width={150} caption={'Statü'} />
                            <Column dataField={'gun'} width={90} caption={'Gün'} />
                            <Column dataField={'pek'} width={150} caption={'Pek'} dataType="number" format={ondalikFormat} />

                            <Column dataField={'toplamGun'} width={90} caption={'Toplam-Gün'} visible={true} />
                            <Column dataField={'toplamPek'} width={150} caption={'Toplam-Pek'} dataType="number" format={ondalikFormat} visible={true} />
                            <Column dataField={'cakismaGun'} width={90} caption={'Çakışma-Gün'} visible={true} />
                            <Column dataField={'cakismaPek'} width={150} caption={'ÇAkışma-Pek'} dataType="number" format={ondalikFormat} visible={true} />

                            <Column dataField={'asgariUcretKati'} width={90} caption={'Asgari Ücret Katı'} />
                            <Column dataField={'basamak4b'} width={250} caption={'Basamak-4b'} dataType="string" visible={true} />
                            <Column dataField={'uyariMesaji'} width={250} caption={'Uyarı'} dataType="string" visible={true} />
                            <Column dataField={'bosColumn'} width={150} caption={''} dataType="string" visible={true} />
                            <Summary  >
                                <GroupItem
                                    column="gun"
                                    summaryType="sum"
                                    valueFormat="decimal"
                                    displayFormat="Toplam: {0}"
                                    showInGroupFooter={true} />
                                <GroupItem
                                    column="pek"
                                    summaryType="sum"
                                    valueFormat="currency"
                                    // precision={2}
                                    displayFormat="Toplam: {0}"
                                    showInGroupFooter={true}
                                    format={decimalFormat} />
                            </Summary>
                            <SortByGroupSummaryInfo summaryItem="count" />
                        </DataGrid>
                    </Tab>

                    <Tab title="Çalışma Yıl Bilgileri">
                        <DataGrid
                            className={props.data == null ? 'gridCalismaYilDetay' : "gridCalismaYilDetayPopup"}
                            width="100%"
                            dataSource={calismaYilDetay}
                            key="id"
                            keyExpr="id"
                            showBorders={true}
                            focusedRowEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={"widget"}
                            columnAutoWidth={false}
                            selection={{ mode: 'single', deferred: true }}
                        >
                            <FilterRow visible={true} />
                            <Export enabled={true} />
                            <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                            <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={true} />

                            <Paging defaultPageSize={60} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                            {/* <Column dataField={'id'} width={90} caption={'Id'} visible={false} /> */}
                            <Column dataField={'adi'} width={90} caption={'Adı'} groupIndex={0} />
                            <Column dataField={'yil'} width={90} caption={'Yıl'} />
                            <Column dataField={'gun'} width={90} caption={'Gün'} />
                            <Column dataField={'pek'} width={150} caption={'Pek'} dataType="number" format={ondalikFormat} />
                            <Column dataField={'yilCarpan'} width={150} caption={'Yıl Çarpan'} dataType="number" format={ondalikFormat} />
                            <Column dataField={'yilDeger'} width={150} caption={'Yıl Değer'} dataType="number" format={ondalikFormat} />
                            <Column dataField={'bosColumn'} width={150} caption={''} dataType="string" visible={true} />

                            <Summary  >
                                <GroupItem
                                    column="gun"
                                    summaryType="sum"
                                    valueFormat="decimal"
                                    displayFormat="Toplam: {0}"
                                    showInGroupFooter={true} />
                                <GroupItem
                                    column="pek"
                                    summaryType="sum"
                                    valueFormat="currency"
                                    // precision={2}
                                    displayFormat="Toplam: {0}"
                                    showInGroupFooter={true}
                                    format={decimalFormat} />
                            </Summary>
                            <SortByGroupSummaryInfo summaryItem="count" />
                        </DataGrid>
                    </Tab>
                    <Tab title="B AYLIĞI ALT SINIR">
                        <DataGrid
                            className={props.data == null ? 'gridBayligi' : "gridBayligiPopup"}
                            width="100%"
                            dataSource={calismaYilAsgariUcretDetay}
                            key="id"
                            keyExpr="id"
                            showBorders={true}
                            focusedRowEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={"widget"}
                            columnAutoWidth={false}
                            selection={{ mode: 'single', deferred: true }}
                        >
                            <FilterRow visible={true} />
                            <Export enabled={true} />
                            <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                            <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={true} />

                            <Paging defaultPageSize={60} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                            {/* <Column dataField={'id'} width={90} caption={'Id'} visible={false} /> */}
                            <Column dataField={'adi'} width={90} caption={'Adı'} groupIndex={0} />
                            <Column dataField={'yil'} width={90} caption={'Yıl'} />
                            <Column dataField={'gun'} width={90} caption={'Gün'} />
                            <Column dataField={'asgariUcretGunluk'} width={150} caption={'Asgari GK'} dataType="number" format={ondalikFormat} />
                            <Column dataField={'yilCarpan'} width={150} caption={'Yıl Çarpan'} dataType="number" format={ondalikFormat} />
                            <Column dataField={'yilDeger'} width={150} caption={'Yıl Değer'} dataType="number" format={ondalikFormat} />
                            <Column dataField={'bosColumn'} width={150} caption={''} dataType="string" visible={true} />

                            <Summary  >
                                <GroupItem
                                    column="gun"
                                    summaryType="sum"
                                    valueFormat="decimal"
                                    displayFormat="Toplam: {0}"
                                    showInGroupFooter={true} />
                                <GroupItem
                                    column="yilDeger"
                                    summaryType="sum"
                                    valueFormat="currency"
                                    // precision={2}
                                    displayFormat="Toplam: {0}"
                                    showInGroupFooter={true}
                                    format={decimalFormat} />
                            </Summary>
                            <SortByGroupSummaryInfo summaryItem="count" />
                        </DataGrid>
                    </Tab>

                    <Tab title="Emeklilik Koşulları" >
                        <DataGrid
                            className={props.data == null ? 'gridEmeklilikKosulDetay' : "gridEmeklilikKosulDetayPopup"}
                            width="100%"
                            dataSource={emeklilikKosulDetay}
                            key="id"
                            keyExpr="id"
                            showBorders={true}
                            focusedRowEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={"widget"}
                            columnAutoWidth={false}
                            selection={{ mode: 'single', deferred: true }}
                        >
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={true} />
                            <FilterRow visible={true} />
                            <Export enabled={true} />
                            <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                            <Scrolling columnRenderingMode="virtual" showScrollbar="always" />

                            <Paging defaultPageSize={1000} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                            {/* <Column dataField={'id'} width={90} caption={'Id'} visible={false} /> */}

                            <Column dataField={'adi'} width={90} caption={'Adı'} />
                            <Column dataField={'kanunBilgi'} width={90} caption={'Kanun'} />

                            <Column dataField={'belgeTuru'} width={90} caption={'Belge Türü'} />
                            <Column dataField={'emeklilikSartSigSure'} width={90} caption={'Sigortalılık Süre-Yıl'} />
                            <Column dataField={'emeklilikSartSigSureAy'} width={90} caption={'Sigortalılık Süre-Ay'} />
                            <Column dataField={'emeklilikSartSigYas'} width={90} caption={'Yaş'} />
                            <Column dataField={'emeklilikSartSigGun'} width={90} caption={'Gün'} />

                            <Column dataField={'bosColmun'} width={90} caption={''} />

                        </DataGrid>
                    </Tab>

                    <Tab title="Hizmet Ekle">
                        <Item itemType="group" colCount={6} colSpan={6}>
                            <Item disabled={false} editorType={'dxSelectBox'} // dataField={baslangicDonem}
                                editorOptions={{
                                    dataSource: belgeTuruDataSource,
                                    value: belgeTuru,
                                    valueExpr: "id",
                                    displayExpr: "name",
                                    placeholder: "Select a value...",
                                    searchEnabled: true,
                                    searchMode: "startswith",
                                    searchExpr: "name",
                                    onValueChanged: onBelgeTuruValueChanged
                                }}>
                                <RequiredRule message="Belge Türü bilgisi gerekli" />
                                <Label text='Belge Türü' />
                            </Item>
                            <Item disabled={false} editorType={'dxSelectBox'} // dataField={baslangicDonem}
                                editorOptions={{
                                    dataSource: storeHesaplaDetayTuru,
                                    value: hesaplaDetayTuru,
                                    valueExpr: "id",
                                    displayExpr: "name",
                                    placeholder: "Select a value...",
                                    searchEnabled: true,
                                    searchMode: "startswith",
                                    searchExpr: "name",
                                    onValueChanged: onHesaplaDetayTuruChanged
                                }}>
                                <RequiredRule message="Detay Türü bilgisi gerekli" />
                                <Label text='Detay Türü' />
                            </Item>
                            <Item disabled={false} editorType={'dxDateBox'} // dataField={baslangicDonem}
                                editorOptions={{
                                    value: baslangicDonem,
                                    stylingMode: 'outlined',
                                    readOnly: false,
                                    type: "date",
                                    displayFormat: "dd.MM.yyyy",
                                    onValueChanged: onBaslangicDonemValueChanged
                                }}>
                                <RequiredRule message="Donem bilgisi gerekli" />
                                <Label text='Başlangıç' />
                            </Item>
                            <Item disabled={false} editorType={'dxDateBox'}  //dataField={bitisDonem}
                                editorOptions={{
                                    value: bitisDonem,
                                    stylingMode: 'outlined',
                                    readOnly: false,

                                    type: "date",
                                    displayFormat: "dd.MM.yyyy",
                                    onValueChanged: onBitisDonemValueChanged
                                }}>
                                <RequiredRule message="Donem bilgisi gerekli" />
                                <Label text='Bitiş' />
                            </Item>
                            <Item disabled={false} editorType={'dxNumberBox'}  //dataField={asgariUcretOran}
                                editorOptions={{
                                    showSpinButtons: false,
                                    showClearButton: false,
                                    value: asgariUcretOran,
                                    //defaultValue: asgariUcretOran,
                                    format: "0.00",
                                    min: 1,
                                    max: 7.5,
                                    onValueChanged: onAsgariUcretOranValueChanged
                                }}>
                                <RequiredRule message="Oran bilgisi gerekli" />
                                <Label text='Oran' />
                            </Item>
                            <Item >
                                <Button icon="find" width={150} text="Detay Ekle" type={'success'} style={{ fontSize: "15px" }} onClick={detayEkle}></Button>
                                <Button icon="clear" width={150} text="Temizle" type={'success'} style={{ fontSize: "15px" }} onClick={hizmetDatasourceTemizle}></Button>
                            </Item>

                        </Item>
                        <Item itemType="group" colCount={4} colSpan={4}>
                            <DataGrid
                                className={props.data == null ? 'gridHizmetEkle' : "gridHizmetEklePopup"}
                                //id="gridContainer"
                                width="100%"
                                dataSource={hizmetEkleDataSource}
                                key="id"
                                //keyExpr="id"
                                showBorders={true}
                                // allowColumnReordering={true}
                                //focusedRowEnabled={true}
                                allowColumnResizing={true}
                            //columnResizingMode={"widget"}
                            //columnAutoWidth={false}
                            // selection={{ mode: 'single', deferred: true }}
                            >
                                <FilterRow visible={true} />
                                <Export enabled={true} />
                                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                                <GroupPanel visible={true} />
                                <Grouping autoExpandAll={true} />
                                <Paging enabled={true} />
                                <Paging defaultPageSize={60} />
                                <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />
                                <Column type="buttons" caption={'İşlem'}
                                    buttons={[
                                        {
                                            hint: 'Sil', icon: 'remove',
                                            onClick: (e) => { deleteDetay(e.row.data); }
                                        }
                                    ]}
                                />
                                <Column dataField={'id'} width={50} caption={'id'} visible={false} />
                                <Column dataField={'donem'} width={90} caption={'Dönem'} />
                                <Column dataField={'sigortaKolu'} width={90} caption={'Sigorta Kolu'} />
                                <Column dataField={'gun'} width={90} caption={'Gün'} />
                                <Column dataField={'pek'} width={90} caption={'Pek'} dataType="number" format={ondalikFormat} />
                                <Column dataField={'asgariUcretKati'} width={90} caption={'Asgari Ücret Katı'} dataType="number" format={ondalikFormat} />
                                <Column dataField={'hesaplaDetayTuru'} width={90} caption={'Hesap Türü'} />
                                <Column dataField={'donemMaliyet'} width={90} caption={'Maliyet'} dataType="number" format={ondalikFormat} />
                                <Column dataField={'maasOranGunKatsayi'} width={90} caption={'Katsayı'} dataType="number" format={ondalikFormat} />
                                {/* <Column dataField={'bosColumn'} width={150} caption={''} dataType="string" visible={true} /> */}

                            </DataGrid>
                        </Item>

                    </Tab>
                </TabbedItem>

            </Form>

        </div>
    )
}

export default HesapForm;
